import { styled } from '@/styled-system/jsx';

// Helper function to apply no-user-select styles
const noUserSelectStyles = {
  WebkitTouchCallout: 'none',
  WebkitUserSelect: 'none',
  KhtmlUserSelect: 'none',
  MozUserSelect: 'none',
  msUserSelect: 'none',
  userSelect: 'none',
  WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
};

export const MapWrapper = styled('section', {
  base: {
    ...noUserSelectStyles,
    height: '100%',
    width: '100%',
    position: 'absolute',
    right: '0px',
    left: '0px',
    md: {
      display: 'inline-block',
      paddingRight: 'sidebarMd',
      top: '0',
    },
    xxl: {
      paddingRight: 'sidebarXl',
    },
  },
});
